import { Injectable } from '@angular/core';

interface Draft {
  content: string;
  files: File[];
}

@Injectable({
  providedIn: 'root'
})
export class DraftService {

  private drafts = new Map<string, Draft>();
  /** Turns another surface hands to a conversation, sent once when it opens (ConversationComponent.sendQueuedTurn). */
  private queued = new Map<string, Draft>();

  saveDraft(conversationId: string, content: string, files: File[] = []): void {
    const hasContent = !!content?.trim();
    const hasFiles = files.length > 0;
    if (hasContent || hasFiles) {
      this.drafts.set(conversationId, { content: hasContent ? content : '', files: [...files] });
    } else {
      this.drafts.delete(conversationId);
    }
  }

  getDraft(conversationId: string): string {
    return this.drafts.get(conversationId)?.content || '';
  }

  getDraftFiles(conversationId: string): File[] {
    const files = this.drafts.get(conversationId)?.files;
    return files ? [...files] : [];
  }

  /** Any conversation holds unsent text or files (kept in memory only: a reload loses them). */
  hasDrafts(): boolean {
    return this.drafts.size > 0 || this.queued.size > 0;
  }

  /**
   * Hand a turn to `conversationId` to SEND (not just stage) the next time it
   * opens — through the conversation's own send path, so its files upload the
   * way the composer's do (Chat's "Send this to <agent>", 2026-11-03).
   */
  queueSend(conversationId: string, content: string, files: File[] = []): void {
    if (!content?.trim() && !files.length) return;
    this.queued.set(conversationId, { content: content?.trim() ? content : '', files: [...files] });
  }

  /** The turn queued for `conversationId`, removed (it is sent once). */
  takeQueuedSend(conversationId: string): Draft | null {
    const queued = this.queued.get(conversationId) ?? null;
    this.queued.delete(conversationId);
    return queued;
  }

  clearDraft(conversationId: string): void {
    this.drafts.delete(conversationId);
  }
}
